import { Box, Button } from '@chakra-ui/react'
import React from 'react'
import '../Styles/home.css'
import Typewriter  from 'typewriter-effect';
import { FaGithub, FaLinkedin } from "react-icons/fa";
import 'aos/dist/aos.css';
import AOS from 'aos';

const Home = () => {
  
  AOS.init()
  return (
    <Box  className="home">
      {/* Text */}
       <Box className="text" >
            {/* Name */}
            <Box className="name_Text">
              <h1 style={{fontWeight:"100"}}>Hello 👋,I'm</h1>
              <Typewriter 
              className="Typewriter__wrapper"
                 onInit={(typewriter) => {
                  typewriter.typeString('Aniket Bansal')
                     .pauseFor(1000)
                     .deleteAll()
                          .start();
                           }}
                           options={{
                            autoStart: true,
                            loop: true,
                            skipAddStyles:true,
                           }}
                          
                         />
            </Box>
            {/* profession */}
            <Box className="profession">
              <h1>I'm</h1>
            <Typewriter 
               options={{
                   strings: ['Engineer', 'MERN Stack Developer'],
                  autoStart: true,
                  loop: true,
                  delay:100,
                  pauseFor:1100
                   }}
                    />
            </Box>
            {/* Summary */}
            <Box className="summary">
              <h3>
              <strong style={{fontSize:"40px",color:"rgb(225, 51, 51)"}}>A</strong>nalytical and detail-oriented aspiring Full Stack Developer. Capable of writing user-oriented solutions and production-optimised codes using MERN languages. Collaborative, team player who is proficient in working with teams and executing a targate-oriented project. Interested in obtaining a Web Developer position to work on enhancing the product experience﻿.
              </h3>
            </Box>
            {/* Social Icons */}
            <Box className="social">
              <a href="https://github.com/Aniket-bansal" target="_blank" rel="noreferrer"><FaGithub size="40px"/></a>
              <a href="https://www.linkedin.com/in/aniket-bansal-dev/" target="_blank" rel="noreferrer"><FaLinkedin size="40px" /></a>
            </Box>
            {/* Resume Button */}
            <Box className="resume">
            <a href="./Aniket_Bansal_Resume.pdf" target="_blank" download><Button>Resume</Button></a>
            </Box>
       </Box>
       {/* image */}
       <Box className="profile_img"></Box>
    </Box>
  )
}

export default Home